<template>
  <div
    class="comp-container__editor"
    :class="{ 'comp-container__editor__readonly': readOnly }"
  >
    <Toolbar
      class="comp-container__editor-toolbar"
      ref="toolbar"
      :mode="mode"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      @mouseenter.native="handleMouseenter"
    />
    <Editor
      ref="editor"
      class="comp-container__editor-content"
      v-model="html"
      :mode="mode"
      :defaultConfig="editorConfig"
      @onCreated="onEditorCreated"
      @onChange="onChange"
      @customPaste="customPaste"
      @onMaxLength="onMaxLength"
      @onFocus="onFocus"
      @onBlur="onBlur"
      @onDestroyed="onDestroyed"
      @keydown.native="onKeydown"
    />
    <!-- <div v-html="html"></div> -->
    <!-- {{ html }} -->
  </div>
</template>

<script>
import { formatTimeBySecond } from "@saas/components/src";
import Vue from "vue";
import "@wangeditor/editor/dist/css/style.css";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import {
  Boot,
  DomEditor,
  SlateTransforms,
  SlateElement,
  SlateEditor,
} from "@wangeditor/editor";

import markdownModule from "@wangeditor/plugin-md";
import formulaModule from "@wangeditor/plugin-formula";
import {
  markBlock,
  MARK_BLOCK_MENU_KEY,
  MARK_BLOCK_ELEMENT_TYPE,
} from "./modules/mark-block";
import markdownExtendModule from "./modules/markdown-extend";
import {
  qaBlock,
  QA_BLOCK_MENU_KEY,
  QA_BLOCK_ELEMENT_TYPE,
} from "./modules/qa-block";
import {
  imgLoadingBlock,
  IMG_LOADING_BLOCK_MENU_KEY,
  IMG_LOADING_BLOCK_TYPE,
} from "./modules/image-loading-block";
import { marked } from "marked";
import { videoScreenShot } from "./buttons/videoScreenShot.js";
import { htmlToContent } from "./utils/htmlToContent.js";
import {
  sanitizeHtmlLists,
  extractFormulas,
  replaceMathDelimiters,
  escapeLatexInString,
  processListItemHtml,
  htmlToSlate,
} from "./utils/index.js";
// 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册。
Boot.registerModule(markdownModule);
Boot.registerModule(formulaModule);
Boot.registerModule(markBlock);
Boot.registerModule(qaBlock);
Boot.registerModule(markdownExtendModule);
Boot.registerModule(imgLoadingBlock);
Boot.registerMenu(videoScreenShot);

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    lessonInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    // 图片上传大小
    imageSizeLimit: {
      type: Number,
      default: 1024 * 1024 * 1,
    },
    // 工具栏配置 // 默认展示全部
    toolbarKeys: {
      type: Array,
      default: () => {
        return null;
      },
    },
    mode: {
      type: String,
      default: "simple",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 编辑器实例
      editor: null,
      // 工具栏实例
      toolbar: null,
      html: ``,
      startCreate: true,
      toolbarConfig: {
        modalAppendToBody: false,
      },
      editorConfig: {
        readOnly: this.readOnly,
        placeholder: this.placeholder,
        maxLength: this.maxLength,
        pasteTextHandle: this.pasteTextHandle,
        MENU_CONF: {
          uploadImage: {
            maxFileSize: this.imageSizeLimit,
            maxNumberOfFiles: 1,
            customUpload: this.customUploadImage,
          },
          // 覆盖默认菜单配置
          // insert: {
          //   // 插入菜单配置
          //   menuKeys: ["insertFormula", MARK_BLOCK_MENU_KEY, QA_BLOCK_MENU_KEY],
          // },
        },
        // 选中公式时的悬浮菜单
        // hoverbarKeys: {
        //   formula: {
        //     menuKeys: ["editFormula"], // “编辑公式”菜单
        //   },
        // },
      },
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val && val !== this.html) {
          this.html = val;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleMouseenter() {
      if (this.editor) {
        this.editor.focus();
      }
    },
    // 编辑器创建完毕时触发
    onEditorCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.$emit("created", this.editor);
      this.$nextTick(() => {
        this.initEditor();
      });
    },
    // 编辑器内容变化时触发
    onChange() {
      if (this.editor) {
        this.$emit("input", this.editor.getHtml());
      }
    },
    // 编辑器内容长度超过限制时触发
    onMaxLength(e) {
      console.log("onMaxLength>>>>", e);
    },
    // 编辑器聚焦
    onFocus(e) {
      console.log("onFocus>>>>", e);
    },
    // 编辑器失焦时触发
    onBlur(e) {
      console.log("onBlur>>>>", e);
    },
    // 编辑器销毁时触
    onDestroyed(e) {
      console.log("onDestroyed>>>>", e);
    },
    onKeydown(event) {
      console.log("onKeydown>>>>", event);
      // 全选 // 兼容 window和mac
      // 检测Ctrl+A组合键（适用于Windows/Linux/Mac）
      if ((event.ctrlKey || event.metaKey) && event.key === "a") {
        // console.log("全选");
        // // 禁止编辑器滚动
        // const scrollDom = this.$refs.editor.$el.querySelector(".w-e-scroll");
        // // scrollDom.style.overflowY = "hidden";
        // event.preventDefault();
        // return false;
      }
    },
    getInstance() {
      return this.editor;
    },
    // 初始化编辑器
    initEditor() {
      this.toolbar = DomEditor.getToolbar(this.editor);
      this.setToolbarConfig();
      this.setHoverbarConfig();
      this.registerEvents();
      // this.html = this.transFormStr(this.value || "");
    },
    // 注册监听事件
    registerEvents() {
      // 插入标记块
      this.editor.on("xhInsertMarkBlock", (data = {}) => {
        this.insertMarkBlock(data);
      });
      // 插入QA块
      this.editor.on("xhInsertQABlock", (data = {}) => {
        this.insertQABlock(data);
      });
      // 插入图片
      this.editor.on("xhInsertImage", (data = {}) => {
        this.insertImgLoadingBlock(data);
      });
      // 插入html
      this.editor.on("xhInsertHtml", (html = "") => {
        this.insertHtml(html);
      });
      // 当点击插入标记块菜单，通知外部
      this.editor.on("xhEmitInsertMarkBlock", (data = {}) => {
        this.$emit("noticeInsertMarkBlock", data);
      });
      // 当点击视频截图菜单，通知外部
      this.editor.on("xhEmitInsertVideoScreenShot", (data = {}) => {
        this.$emit("noticeInsertVideoScreenShot");
      });
      // 当点击标记块的时间跳转，通知外部
      this.editor.on("jumpPlayTime", (data = "") => {
        this.$emit("noticeJumpPlayTime", data);
      });
      // 图片上传状态
      this.editor.on("xhInsertImageUploadStatus", (data = {}) => {
        this.$emit("noticeImageUploadStatus", data);
      });
      // 标记块上传状态
      this.editor.on("xhInsertMarkBlockUploadStatus", (data = {}) => {
        this.$emit("noticeMarkBlockUploadStatus", data);
      });
    },
    // 配置工具栏
    setToolbarConfig() {
      const curToolbarConfig = this.toolbar.getConfig();
      if (this.toolbarKeys && Array.isArray(this.toolbarKeys)) {
        curToolbarConfig.toolbarKeys = this.toolbarKeys;
      }
      // curToolbarConfig.insertKeys = {
      //   index: 0, // 插入的位置，基于当前的 toolbarKeys
      //   keys: [
      //     "insertFormula",
      //     MARK_BLOCK_MENU_KEY,
      //     QA_BLOCK_MENU_KEY,
      //     IMG_LOADING_BLOCK_MENU_KEY,
      //   ],
      // };
    },
    // 配置hoverbar
    setHoverbarConfig() {
      const curHoverbarConfig = this.editor.getConfig().hoverbarKeys;
      curHoverbarConfig.formula = {
        menuKeys: ["editFormula"], // “编辑公式”菜单
      };
    },
    // 获取html
    getHtml() {
      if (this.editor) {
        return this.editor.getHtml();
      } else {
        return "";
      }
    },
    // 自定义粘贴。可阻止编辑器的默认粘贴，实现自己的粘贴逻辑。(可以实现复制粘贴 word ，有图片)
    customPaste(editor, event, callback) {
      const html = event.clipboardData.getData("text/html"); // 获取粘贴的 html
      const text = event.clipboardData.getData("text/plain"); // 获取粘贴的纯文本
      const rtf = event.clipboardData.getData("text/rtf"); // 获取 rtf 数据（如从 word wsp 复制粘贴）
      if (html) {
        if (html.indexOf("<img") !== -1) {
          // 获取每一个图片的url，然后把img标签替换成自定义的标签
          const newHtml = html.replace(/<img[^>]*>/g, (match) => {
            const img = match.match(/src="([^"]+)"/);
            if (img && img[1]) {
              const url = img[1];
              return `<div
              data-w-e-type="${IMG_LOADING_BLOCK_TYPE}"
              data-url="${url}"
            >
            </div>`;
            }
          });
          editor.dangerouslyInsertHtml(newHtml);
          event.preventDefault();
          callback(false);
        }
      } else if (text) {
        const res = this.transFormStr(text);
        editor.dangerouslyInsertHtml(res);
        event.preventDefault();
        callback(false);
      } else {
        console.log("text", text);
      }
    },
    // 自定义上传图片
    customUploadImage(file, insertFn) {
      SlateTransforms.insertNodes(this.editor, [
        {
          type: IMG_LOADING_BLOCK_TYPE,
          file,
          children: [{ text: "" }],
        },
      ]);
    },

    // 把字符串中的markdwon，和公式转换为span标签
    transFormStr(str) {
      // 手动吧#  转换为h1标签
      str = str.replace(/^# (.*)/gm, (match) => `<h1>${match.slice(2)}</h1>`);
      str = replaceMathDelimiters(str);
      str = escapeLatexInString(str);
      str = marked.parse(str);
      str = extractFormulas(str);
      // 处理列表嵌套问题，列表嵌套展示有问题
      str = processListItemHtml(str);
      return str;
    },
    // 插入问答块
    insertQABlock(params) {
      let { qContent, aContent } = params;
      console.log("params", params);
      qContent = this.transFormStr(qContent) || "";
      aContent = this.transFormStr(aContent) || "";
      console.log("aContent", aContent);
      qContent = htmlToSlate(qContent, this.editor);
      aContent = htmlToSlate(aContent, this.editor);
      if (this.editor.selection) {
        // 如果当前是空 p ，则删除该 p
        if (DomEditor.isSelectedEmptyParagraph(this.editor)) {
          SlateTransforms.removeNodes(this.editor, { mode: "highest" });
        }
      }
      // 解析 aContent
      const qNode = {
        type: "paragraph",
        children: [...qContent],
      };
      const aNode = {
        type: "paragraph",
        children: [...aContent],
      };

      const QABlock = {
        type: QA_BLOCK_ELEMENT_TYPE,
        children: [qNode, aNode],
      };
      SlateTransforms.insertNodes(this.editor, [QABlock], {
        mode: "highest",
      });
    },
    // 插入标记块
    // 只能在顶级节点插入
    insertMarkBlock(params) {
      const { type, content, imgUrl, time, file } = params;
      if (this.editor.selection) {
        // 如果当前是空 p ，则删除该 p
        if (DomEditor.isSelectedEmptyParagraph(this.editor)) {
          SlateTransforms.removeNodes(this.editor, { mode: "highest" });
        }
      }
      const markBlock = {
        type: MARK_BLOCK_ELEMENT_TYPE,
        markType: type,
        file: file,
        imgUrl: imgUrl || "",
        time: time,
        children: [{ text: content || "" }],
        lessonInfo: this.lessonInfo,
        showTime: formatTimeBySecond(time),
      };
      SlateTransforms.insertNodes(this.editor, [markBlock], {
        mode: "highest",
      });
    },
    // 插入图片块
    insertImgLoadingBlock(params) {
      const { url, file } = params;
      if (this.editor.selection) {
        // 如果当前是空 p ，则删除该 p
        if (DomEditor.isSelectedEmptyParagraph(this.editor)) {
          SlateTransforms.removeNodes(this.editor, { mode: "highest" });
        }
      }
      SlateTransforms.insertNodes(this.editor, [
        {
          type: IMG_LOADING_BLOCK_TYPE,
          url: url,
          file: file,
          children: [{ text: "" }],
        },
      ]);
    },
    // 插入html
    insertHtml(html) {
      const dealHtml = this.transFormStr(html);
      this.editor.focus();
      this.editor.dangerouslyInsertHtml(dealHtml);
    },
    // 滚动到最底部
    scrollToBottom() {
      const container = this.editor.getEditableContainer();
      const scrollDom = container.querySelector(".w-e-scroll");
      if (scrollDom) {
        scrollDom.scrollTo({
          top: scrollDom.scrollHeight,
          behavior: "smooth",
        });
      }
    },
  },
  mounted() {
    // 兼容 Electron 中不支持 :has 选择器的问题
    // 监听 body 变化，当 w-e-modal 出现且包含 .babel-container 时，添加辅助类
    this.observer = new MutationObserver((mutations) => {
      const modals = document.querySelectorAll(".w-e-modal");
      modals.forEach((modal) => {
        if (modal.querySelector(".babel-container")) {
          modal.classList.add("has-babel-container");
        } else {
          modal.classList.remove("has-babel-container");
        }
      });
    });
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
    // off eventbus
  },
});
</script>
<style scoped lang="scss">
.comp-container__editor ::v-deep {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  h1 {
    font-size: 2em;
    font-weight: bold;
  }
  h2 {
    font-size: 1.5em;
    font-weight: bold;
  }
  h3 {
    font-size: 1.17em;
    font-weight: bold;
  }
  h4 {
    font-size: 1em;
    font-weight: bold;
  }
  h5 {
    font-size: 0.83em;
    font-weight: bold;
  }
  .qa-block {
    p {
      padding: 0;
      margin: 0;
      line-height: 24px;
    }
  }
}
.comp-container__editor-toolbar ::v-deep {
  padding: 0 2px;
  min-height: 30px;
  line-height: 30px;
  .w-e-toolbar {
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    & > .w-e-bar-item {
      width: 16px;
      height: 30px;
      padding: 0;
      margin: 0 4px;
      display: flex;
      align-items: center;
      &:first-child {
        button {
          &:before {
            left: -2px;
          }
        }
      }
      & > button {
        width: 16px;
        height: 16px;
        padding: 0;
        &[data-menu-key="xhVideoScreenShotKey"] {
          svg {
            fill: none !important;
          }
        }
        &[data-menu-key="insertFormula"] {
          svg {
            display: none !important;
          }
          background: url("../../../assets/images/wang-editor/formula.png");
          background-size: 100% 100%;
        }
        &[data-menu-key="bold"] {
          svg {
            display: none !important;
          }
          background: url("../../../assets/images/wang-editor/bold.png");
          background-size: 100% 100%;
        }
        &[data-menu-key="underline"] {
          svg {
            display: none !important;
          }
          background: url("../../../assets/images/wang-editor/underline.png");
          background-size: 100% 100%;
        }
        &[data-menu-key="italic"] {
          svg {
            display: none !important;
          }
          background: url("../../../assets/images/wang-editor/italic.png");
          background-size: 100% 100%;
        }
        svg {
          width: 16px;
          height: 16px;
          &:nth-child(2) {
            display: none;
          }
        }
      }
      &.xh-mark-block-menu-item {
        position: relative;
        .xh-mark-block-drop-panel {
          top: 100% !important;
          left: 50% !important;
          right: auto !important;
          margin-top: 4px;
          transform: translateX(-50%);
        }
      }
      .xh-mark-block-drop-panel {
        padding: 0;
        min-width: unset;
        border: unset;
        box-shadow: unset;
        background: transparent;
        // width: 94px;
        // height: 104px;
        // background: #14171c;
        // border-radius: 12px;
        // min-width: 94px;
        // padding: 10px 12px;
        & > div {
          width: 100%;
          height: 100%;
        }
        ul {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
        }
        li {
          cursor: pointer;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          img {
            margin-right: 6px;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }

  .w-e-bar-divider {
    width: 1px;
    height: 18px;
    background: #ffffff;
  }
}
.comp-container__editor-content ::v-deep {
  flex: 1;
  min-height: 200px;
  font-size: 14px;
  .w-e-scroll {
    & > div {
      & > p {
        margin: 15px 0 !important;
      }
      & > div {
        margin: 0 !important;
      }
    }
  }
  .w-e-text-placeholder {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: #c9cdd4;
  }
  // TODO 选择器需要确定
  .w-e-modal.has-babel-container {
    left: 5% !important;
    top: 5% !important;
    width: 90%;
    max-width: 90%;
    height: 164px;
    background: #fff;
    padding: 10px;
    border: none;
    border-radius: 12px;
    & > .btn-close {
      // display: none;
    }
    .babel-container {
      span {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .button-container {
      margin-bottom: 0;
      text-align: right;
      button {
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 6px;
        border: none;
        color: #fff;
        margin-bottom: 0;
      }
    }
  }
  markblock {
    .qa-time {
      background: red;
      position: relative;
      &:hover {
        background: #f2f3f5 !important;
        border: 1px solid #f2f3f5;
        &::after {
          content: "";
          position: absolute;
          width: 12px;
          height: 12px;
          background: url("../../../assets/images/wang-editor/play-1.png");
          background-color: #fff;
          background-size: 12px 12px;
          border-radius: 50%;
          left: 5px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .qa-title {
      position: relative;
      display: flex;
      align-items: center;
      &:hover {
        &::after {
          content: "";
          position: absolute;
          width: 20px;
          height: 20px;
          background: url("../../../assets/images/wang-editor/edit.png");
          background-size: 20px 20px;
          right: 1px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  qablock {
    word-wrap: break-word;
    word-break: break-all;
    .q-block {
      color: #4e5969;
    }
    .a-block-content {
      position: relative;
      &:has(span[data-slate-length="0"]) {
        &::before {
          display: none;
        }
      }
      &::before {
        display: none;
        content: "请输入问题答案";
        position: absolute;
        left: 0;
        top: 0;
        height: 24px;
        line-height: 24px;
        color: #c9cdd4;
      }
    }
    .q-block-content {
      position: relative;
      &:has(span[data-slate-length="0"]) {
        &::before {
          display: none;
        }
      }
      &::before {
        display: none;
        content: "请输入提问问题";
        position: absolute;
        left: 0;
        top: 0;
        height: 24px;
        line-height: 24px;
        color: #c9cdd4;
      }
    }
  }
}
.comp-container__editor__readonly ::v-deep {
  qablock,
  markblock,
  imgloading {
    .delete-icon {
      display: none !important;
    }
  }
  markblock {
    .qa-title {
      &:hover {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
